export interface ISalary {
  currency?: string;
  from?: number;
  negotiable?: boolean;
  per?: string;
  to?: number;
  bonus?: string;
}

export class Salary {
  currency?: string;
  from?: number;
  negotiable?: boolean;
  per?: string;
  to?: number;

  constructor( salary: ISalary = {} ) {
    this.currency = salary.currency === '$' ? '' : salary.currency;
    this.from = salary.from || null;
    this.negotiable = salary.negotiable || false;
    this.per = salary.per || '';
    this.to = salary.to || null;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/salary.ts